import {
  GET_PROVIDER,
  GET_PROVIDER_FAIL,
  GET_PROVIDER_SUCCESS,
  GET_PROVIDERS,
  GET_PROVIDERS_FAIL,
  GET_PROVIDERS_SUCCESS,
  ADD_NEW_PROVIDER,
  ADD_PROVIDER_SUCCESS,
  ADD_PROVIDER_FAIL,
  UPDATE_PROVIDER,
  UPDATE_PROVIDER_SUCCESS,
  UPDATE_PROVIDER_FAIL,
  DELETE_PROVIDER,
  DELETE_PROVIDER_SUCCESS,
  DELETE_PROVIDER_FAIL,
  SET_STATE_PROVIDER,
  UPDATE_PROVIDER_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_PROVIDER,
  payload: loading,
})

export const getProviders = ( params ) => ({
  type: GET_PROVIDERS,
  payload: { params },
})

export const getProvidersSuccess = (providers, totalPages, currentPage) => ({
  type: GET_PROVIDERS_SUCCESS,
  payload: {providers:providers, total:totalPages, currentPage:currentPage}
})

export const getProvidersFail = error => ({
  type: GET_PROVIDERS_FAIL,
  payload: error,
})

export const addNewProvider = provider => ({
  type: ADD_NEW_PROVIDER,
  payload: provider,
})

export const addProviderSuccess = provider => ({
  type: ADD_PROVIDER_SUCCESS,
  payload: provider,
})  

export const addProviderFail = error => ({
  type: ADD_PROVIDER_FAIL,
  payload: error,
})

export const updateProvider = provider => ({
  type: UPDATE_PROVIDER,
  payload: provider,
})

export const updateProviderStatus = provider => ({
  type: UPDATE_PROVIDER_STATUS,
  payload: provider,
})

export const updateProviderSuccess = provider => ({
  type: UPDATE_PROVIDER_SUCCESS,
  payload: provider,
})

export const updateProviderFail = error => ({
  type: UPDATE_PROVIDER_FAIL,
  payload: error,
})

export const deleteProvider = provider => ({
  type: DELETE_PROVIDER,
  payload: provider,
})

export const deleteProviderSuccess = id => ({
  type: DELETE_PROVIDER_SUCCESS,
  id,
})

export const deleteProviderFail = error => ({
  type: DELETE_PROVIDER_FAIL,
  payload: error,
})

export const getProvider = () => ({
  type: GET_PROVIDER,
})

export const getProviderSuccess = provider => ({
  type: GET_PROVIDER_SUCCESS,
  payload: provider,
})

export const getProviderFail = error => ({
  type: GET_PROVIDER_FAIL,
  payload: error,
})
